import "./landing.css";

export default function HeroSection({ onLoginClick, onRegisterClick }) {
  return (
    <div
      id="hero-section"
      className="sdx lp-hero" // sdx aktiviert den SDX-Scope
      style={{ "--lp-hero-image": "url('/images/Garage_1.png')" }}
    >
      <div className="lp-hero-media" aria-hidden="true" />

      <div className="lp-hero-inner">
        <h1 className="h1">
          Weniger CO2 heisst weniger Kosten. GreenOne zeigt Ihnen, wo.
        </h1>
        <p className="lp-hero-subtitle">Für Carrossiers gemacht.</p>

        <div className="lp-hero-actions">
          <button
            type="button"
            className="hero-btn hero-btn-secondary"
            onClick={onLoginClick}
          >
            Login
          </button>
          <button
            type="button"
            className="hero-btn hero-btn-primary"
            onClick={onRegisterClick}
          >
            Kostenlos testen
          </button>
        </div>
      </div>
    </div>
  );
}
